import { cn } from "@onair/utils/cn";
import dayjs from "@onair/utils/dayjs";
import Link from "next/link";
import { memo } from "react";

interface CardPostSimpleProps {
	title?: string;
	href?: string;
	createdAt?: string;
	hashTags?: {
		name: string;
		id: number;
	}[];
}
const CardPostSimple: React.FC<CardPostSimpleProps> = ({
	title = "",
	href = "/",
	createdAt,
	hashTags = [],
}) => {
	const twoHashtag = [...hashTags].splice(0, 1);
	const restTagCount = hashTags.length - 1;
	return (
		<div className="card-post group/item rounded-xl overflow-hidden relative">
			<Link href={href} className="flex flex-col h-full">
				<div className={cn("post-item__content", "h-full")}>
					<div className="flex items-center justify-between mb-3">
						<div className="hash-tags flex items-center gap-2">
							{twoHashtag.map((item) => (
								<span
									key={item.id}
									className="bg-gray-100 text-xs rounded-lg px-2 py-1 font-bold text-gray-600"
								>
									{item.name}
								</span>
							))}
							{restTagCount > 0 ? (
								<span className="text-xs">{`+${restTagCount}`}</span>
							) : null}
						</div>
						<div className="post-item__date">
							<time
								dateTime={dayjs(createdAt).format("DD-MM-YYYY")}
								className="text-gray-500 text-xs"
							>
								{dayjs(createdAt).format("D [Tháng] M, YYYY")}
							</time>
						</div>
					</div>
					<h3 className="group-hover/item:underline underline-offset-4 text-lg font-semibold line-clamp-4 leading-snug text-pretty">
						{title}
					</h3>
				</div>
			</Link>
		</div>
	);
};
export default memo(CardPostSimple);
